import React, { useContext } from 'react';
import { Menu, MenuItem, Typography } from '@material-ui/core';
import previewStyle from '../Preview.style';
import { colors } from 'theme/color-palette';
import { CREATE_COPY } from 'constants/constant';
import { UserPortalContext } from 'context/appcontext';
import { FEATURES } from 'helper/basicFeatureFlag';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
const { LIGHT_GREY } = colors;

function ScheduleMenu(props) {
	const portalUserContext = useContext(UserPortalContext);
	const { customerType } = portalUserContext;
	const { anchor, cbOnClose, cbMenuSelect, menu } = props;

	const classes = previewStyle();
	const { DISABLE_CREATE_COPY: disableCreateCopy } = FEATURES[customerType].PREVIEW_PAGE;

	const handleClose = (event) => {
		stopPropagation(event);
		cbOnClose();
	};

	const stopPropagation = (event) => {
		event?.stopPropagation();
	};

	return (
		<Menu
			id={`menu-items`}
			anchorEl={anchor}
			elevation={1}
			style={{ marginTop: 48 }}
			PaperProps={{
				style: {
					width: 203,
					boxShadow: `0 4px 8px 0 ${LIGHT_GREY}, 0 6px 20px 0 ${LIGHT_GREY}`
				}
			}}
			MenuListProps={{
				'aria-labelledby': 'basic-button'
			}}
			open={Boolean(anchor)}
			onClose={handleClose}>
			{menu.map((item) => {
				const Icon = item === 'Save and Exit' ? <ExitToAppIcon /> : null;
				return (
					<MenuItem
						key={item}
						id={item}
						disabled={item === CREATE_COPY && disableCreateCopy}
						className={classes.menuItems}
						onClick={(e) => {
							e.stopPropagation();
							cbMenuSelect(item);
						}}>
						{Icon}
						<Typography>{item}</Typography>
					</MenuItem>
				);
			})}
		</Menu>
	);
}

ScheduleMenu.propTypes = {};

export default ScheduleMenu;
